import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { LandingPage } from './page';

@Component({
  selector: 'app-page-landing',
  template: '<div class="react-page" #container></div>'
})
export class LandingPageComponent extends ReactPageComponent {
  get Component(){
    return LandingPage;
  }
}
